/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Table_Creationdate1Inputs */

const id_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Pembuatan`)
};

const ms_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Penciptaan`)
};

const da_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettelsesdato`)
};

const de_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellungsdatum`)
};

const en_us2_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation Date`)
};

const es_es2_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

const es_mx2_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

const fil_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Paggawa`)
};

const fr_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de création`)
};

const it_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di creazione`)
};

const hu_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létrehozás dátuma`)
};

const nl_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanmaakdatum`)
};

const no_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opprettelsesdato`)
};

const pl_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data utworzenia`)
};

const pt_br2_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de criação`)
};

const pt_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de criação`)
};

const ro_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data creării`)
};

const fi_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luontipäivä`)
};

const sv_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapelsedatum`)
};

const vi_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày tạo`)
};

const tr_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturulma Tarihi`)
};

const cs_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vytvoření`)
};

const bg_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на създаване`)
};

const ru_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата создания`)
};

const uk_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата створення`)
};

const ar_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الإنشاء`)
};

const hi_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्माण तिथि`)
};

const th_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่สร้าง`)
};

const ja_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const zh_cn2_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建日期`)
};

const zh_hant1_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立日期`)
};

const ko_items_table_creationdate1 = /** @type {(inputs: Items_Table_Creationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성 날짜`)
};

/**
* | output |
* | --- |
* | "Creation Date" |
*
* @param {Items_Table_Creationdate1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_table_creationdate1 = /** @type {((inputs?: Items_Table_Creationdate1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Table_Creationdate1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_table_creationdate1(inputs)
	if (locale === "ms") return ms_items_table_creationdate1(inputs)
	if (locale === "da") return da_items_table_creationdate1(inputs)
	if (locale === "de") return de_items_table_creationdate1(inputs)
	if (locale === "en-US") return en_us2_items_table_creationdate1(inputs)
	if (locale === "es-ES") return es_es2_items_table_creationdate1(inputs)
	if (locale === "es-MX") return es_mx2_items_table_creationdate1(inputs)
	if (locale === "fil") return fil_items_table_creationdate1(inputs)
	if (locale === "fr") return fr_items_table_creationdate1(inputs)
	if (locale === "it") return it_items_table_creationdate1(inputs)
	if (locale === "hu") return hu_items_table_creationdate1(inputs)
	if (locale === "nl") return nl_items_table_creationdate1(inputs)
	if (locale === "no") return no_items_table_creationdate1(inputs)
	if (locale === "pl") return pl_items_table_creationdate1(inputs)
	if (locale === "pt-BR") return pt_br2_items_table_creationdate1(inputs)
	if (locale === "pt") return pt_items_table_creationdate1(inputs)
	if (locale === "ro") return ro_items_table_creationdate1(inputs)
	if (locale === "fi") return fi_items_table_creationdate1(inputs)
	if (locale === "sv") return sv_items_table_creationdate1(inputs)
	if (locale === "vi") return vi_items_table_creationdate1(inputs)
	if (locale === "tr") return tr_items_table_creationdate1(inputs)
	if (locale === "cs") return cs_items_table_creationdate1(inputs)
	if (locale === "bg") return bg_items_table_creationdate1(inputs)
	if (locale === "ru") return ru_items_table_creationdate1(inputs)
	if (locale === "uk") return uk_items_table_creationdate1(inputs)
	if (locale === "ar") return ar_items_table_creationdate1(inputs)
	if (locale === "hi") return hi_items_table_creationdate1(inputs)
	if (locale === "th") return th_items_table_creationdate1(inputs)
	if (locale === "ja") return ja_items_table_creationdate1(inputs)
	if (locale === "zh-CN") return zh_cn2_items_table_creationdate1(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_table_creationdate1(inputs)
	return ko_items_table_creationdate1(inputs)
});
export { items_table_creationdate1 as "items.table.creationDate" }